import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder, NgForm } from '@angular/forms';
import { PatientAllergyService } from '@service/patient-facesheet/patient-allergy.service';
import { PatientAllergy, PatientAllAllergyList } from '@models/patient-facesheet/patient-allergy.model';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-allergy-dialog',
  templateUrl: './allergy-dialog.component.html',
  styleUrls: ['./allergy-dialog.component.sass']
})
export class AllergyDialogComponent {
  action: string;
  dialogTitle: string;
  patientAllergyForm: FormGroup;
  patientAllergyItem: PatientAllergy;
  index: number;
  patientId: number;
  allergyId: number;
  id: number;
  patientAllergylist: PatientAllAllergyList;

  constructor(
    public dialogRef: MatDialogRef<AllergyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public patientAllergyService: PatientAllergyService,
    private fb: FormBuilder,
    private datePipe?: DatePipe
  ) {
    // Set the defaults
    this.action = data.action;
    dialogRef.disableClose = true;

    if (this.action === 'edit') {
      this.dialogTitle = 'Patient Allergy';
      this.patientAllergyItem = data.patientItem;      
    } else {
      this.dialogTitle = 'Patient Allergy';
      this.patientAllergyItem = new PatientAllergy();
      this.patientAllergyItem.PatientId = data.patientId;
    }
    this.patientAllergyForm = this.createForm();
  }

  formControl = new FormControl('', [
    Validators.required
  ]);

  getErrorMessage() {
    return this.formControl.hasError('required')
      ? 'Required field'
      : this.formControl.hasError('email')
        ? 'Not a valid email'
        : '';
  }

  createForm(): FormGroup {
    return this.fb.group({
      Id: [this.patientAllergyItem.Id],
      Description: [this.patientAllergyItem.Description],
      FromDate: [this.patientAllergyItem.FromDate],
      Active: [this.patientAllergyItem.DisplayInList],
    });
  }

  onSubmit(formElement: NgForm) {
    this.patientAllergyItem.FromDate = this.datePipe.transform(this.patientAllergyItem.FromDate, "MM/dd/yyyy");
      if (this.patientAllergyItem.Id > 0) {
        this.patientAllergyService.updatePatientAllergy(this.patientAllergyItem);
      }
      else {
        this.patientAllergyService.addPatientAllergy(this.patientAllergyItem);
      }
      this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public confirmAdd(): void {
    let result = this.patientAllergyForm.getRawValue();
    this.patientAllergyItem.Allergy[this.index] = this.patientAllergyItem;
    this.patientAllergyService.addPatientAllergy(result);
    this.dialogRef.close();
  }

}
